import { ICustomValidationFunctionCallContextProvider } from "../../../../Form/CustomizationContexts/ValidatorContext/ICustomValidationFunctionCallContextProvider";
import { BindingPath, ViewModel } from "../../../CoreTypes";
import { IErrorManager } from "../../../ErrorManager/ErrorManager";
import { ILocalizer } from "../../../Localization/ILocalizer";
import { IModel } from "../../../ModelStoring/Model";
import { IPicklistsProvider } from "../../../Picklists/IPicklistsProvider";
import { FormStore } from "../../../Store/CandyStore";
import { ModelEvent } from "../../../EventManagement/ModelEvents/ModelEvent";
import { IEvaluationContext } from "../../../Calculator2/IEvaluationContext";

export type CheckType = "error" | "warning";

export interface IValidationContext {
    localizer: ILocalizer;
    store: FormStore;
    model: IModel;
    picklistsProvider: IPicklistsProvider;
    errorManager: IErrorManager;
    customValidationFunctionCallContextProvider: ICustomValidationFunctionCallContextProvider;
    path: BindingPath;
    evaluationContext: IEvaluationContext;
}

export interface IValueValidator {
    validate(context: IValidationContext, nodeViewModel: ViewModel): ValidationResult | Promise<ValidationResult>;
    asDebugString(): string;
}

export type ValidationResult =
    | {
          valid: true;
          forceValid?: true;
          additionalEvents?: readonly ModelEvent[];
      }
    | {
          valid: false;
          message: undefined | string;
          type: CheckType;
          additionalEvents?: readonly ModelEvent[];
      };

export class ValidationResults {
    public static Valid: ValidationResult = { valid: true };
    public static ForceValid: ValidationResult = { valid: true, forceValid: true };

    public static ValidWithEvents(events?: readonly ModelEvent[]): ValidationResult {
        return this.withEvents(this.Valid, events);
    }

    public static ForceValidEvents(events?: readonly ModelEvent[]): ValidationResult {
        return this.withEvents(this.ForceValid, events);
    }

    public static Invalid = (
        message: undefined | string,
        checkType: CheckType,
        events?: readonly ModelEvent[]
    ): ValidationResult => ({
        valid: false,
        message: message,
        type: checkType,
        additionalEvents: events,
    });

    public static withEvents(originalResult: ValidationResult, events?: readonly ModelEvent[]): ValidationResult {
        return {
            ...originalResult,
            additionalEvents: [...(originalResult.additionalEvents ?? []), ...(events ?? [])],
        };
    }
}
